<template>
    <v-container fluid style="max-width: 1550px; margin-left: auto; margin-right: auto">
        <v-row>
            <v-col cols="12" class="pl-8 pb-1">
                <v-row dense class="d-flex justify-space-between">
                    <v-col cols="12" md="4" class="text-left pa-0 ma-0 d-none d-md-block">
                        <img :src="publicPath + 'login_logo_azara.png'" style="width: 209.5px; height: auto" />
                    </v-col>
                    <v-col cols="12" md="4" class="text-center pa-0 ma-0 d-md-none">
                        <img :src="publicPath + 'login_logo_azara.png'" style="width: 209.5px; height: auto" />
                    </v-col>
                    <v-col cols="12" md="4" class="text-right pl-0 pr-4 d-none d-md-block">
                        <v-btn
                            style="border-radius: 8px"
                            color="#0da6b1"
                            class=".d-sm-block white--text text-none font-weight-bold pa-6 buttons-font"
                            @click="redirect"
                        >
                            {{ $t('buttons.backToWebsite') }}
                        </v-btn>
                    </v-col>
                    <v-col cols="12" md="4" class="text-right pl-1 pr-3 d-md-none">
                        <v-btn
                            style="border-radius: 8px"
                            block
                            color="#0da6b1"
                            class=".d-sm-block white--text text-none font-weight-bold buttons-font"
                            @click="redirect"
                        >
                            {{ $t('buttons.backToWebsite') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row dense class="pl-5">
            <v-col cols="12" class="text-h6 headings-font headings-font-weight">
                {{ $t('labels.servicesForSeafarers') }}
            </v-col>
        </v-row>
        <v-row dense class="pl-5">
            <v-col cols="12" class="text-h4 headings-font headings-font-weight">
                {{ $t('labels.openApplication') }}
            </v-col>
        </v-row>
        <v-row dense class="pl-5 pr-4">
            <v-col cols="12" class="text-h7 descriptionText">
                {{ $t('texts.openApplicationDescription') }}<b>{{ $t('texts.openApplicationLink') }}</b>
            </v-col>
        </v-row>
        <v-row dense class="pl-5 pr-4">
            <v-col cols="12" class="text-h7 descriptionText">
                <i>
                    {{ $t('texts.openApplicationDescription2')
                    }}<b class="link-style" @click="getTemplate()">{{ $t('texts.link') }}</b>
                </i>
            </v-col>
        </v-row>
        <v-row dense class="pl-5 pb-4">
            <v-col cols="12" md="4">
                <v-btn
                    style="border-radius: 8px"
                    color="#f6bb14"
                    class="white--text text-none font-weight-bold pa-6 buttons-font"
                    @click="openModal(false, null, true)"
                >
                    {{ $t('buttons.openApplication') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row dense class="pl-5">
            <v-col cols="12" class="text-h4 headings-font headings-font-weight">
                {{ $t('labels.openVacancies') }}
            </v-col>
        </v-row>
        <v-row dense class="pl-5 pr-4">
            <v-col cols="12" class="text-h7 descriptionText">
                {{ $t('texts.vacancyDescription') }}<b>{{ $t('texts.followInstructions') }}</b>
            </v-col>
        </v-row>
        <v-row dense class="pl-5 pr-4">
            <v-col cols="12" class="text-h7 descriptionText">
                <i>{{ $t('texts.vacancyDescription2') }}</i>
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12">
                <v-col v-for="vacancy in vacanciesList" v-bind:key="vacancy.id">
                    <div
                        class="text-none font-weight-bold cursor-pointer"
                        id="no-background-hover"
                        @click="vacancy.show_more = !vacancy.show_more"
                    >
                        <v-card class="item-height">
                            <v-card-text class="pt-md-1">
                                <v-row no-gutters class="hidden-sm-and-down">
                                    <v-col cols="12" class="d-flex justify-end align-center pa-0 ma-0">
                                        <span v-show="!vacancy.show_more">
                                            <v-icon x-small color="#6F6F6F">fas fa-chevron-down</v-icon>
                                        </span>
                                        <span v-show="vacancy.show_more">
                                            <v-icon x-small color="#6F6F6F">fas fa-chevron-up</v-icon>
                                        </span>
                                    </v-col>
                                </v-row>
                                <v-row dense wrap container>
                                    <v-col cols="12" md="2" class="pr-2">
                                        <v-row dense>
                                            <v-col
                                                :class="{truncateContent: !$vuetify.breakpoint.mobile}"
                                                class="text-body-2 pa-0 cardTextLabel"
                                            >
                                                {{ $t('labels.rankCard').toUpperCase() }} <br />
                                                <v-tooltip top>
                                                    <template v-slot:activator="{on, attrs}">
                                                        <span
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            style="font-size: 1.15rem"
                                                            class="pa-0 cardText"
                                                        >
                                                            <b> {{ vacancy.ranks_display }}</b>
                                                        </span>
                                                    </template>
                                                    <span>{{ vacancy.ranks_display }}</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" md="2" class="pr-2">
                                        <v-row dense>
                                            <v-col
                                                :class="{truncateContent: !$vuetify.breakpoint.mobile}"
                                                class="text-body-2 pa-0 cardTextLabel"
                                            >
                                                {{ $t('labels.vesseltype').toUpperCase() }} &nbsp; <br />
                                                <v-tooltip top>
                                                    <template v-slot:activator="{on, attrs}">
                                                        <span
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            class="text-body-1 pa-0 cardText"
                                                        >
                                                            <b>{{ vacancy.vessel_types_display }}</b>
                                                        </span>
                                                    </template>
                                                    <span>{{ vacancy.vessel_types_display }}</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" md="2" class="pr-2">
                                        <v-row dense>
                                            <v-col
                                                :class="{truncateContent: !$vuetify.breakpoint.mobile}"
                                                class="text-body-2 pa-0 cardTextLabel"
                                            >
                                                {{ $t('labels.salaryCard').toUpperCase() }} <br />
                                                <v-tooltip top>
                                                    <template v-slot:activator="{on, attrs}">
                                                        <span
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            class="text-body-1 pa-0 cardText"
                                                        >
                                                            {{ vacancy.salary }}
                                                        </span>
                                                    </template>
                                                    <span>{{ vacancy.salary }}</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" md="2" class="pr-2">
                                        <v-row dense>
                                            <v-col
                                                :class="{truncateContent: !$vuetify.breakpoint.mobile}"
                                                class="text-body-2 pa-0 cardTextLabel"
                                            >
                                                {{ $t('labels.salaryDetailsCard').toUpperCase() }} <br />
                                                <v-tooltip top>
                                                    <template v-slot:activator="{on, attrs}">
                                                        <span
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            class="text-body-1 pa-0 cardText"
                                                        >
                                                            {{ vacancy.salary_details }}
                                                        </span>
                                                    </template>
                                                    <span>{{ vacancy.salary_details }}</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" md="2" class="pr-2">
                                        <v-row dense>
                                            <v-col
                                                :class="{truncateContent: !$vuetify.breakpoint.mobile}"
                                                class="text-body-2 pa-0 cardTextLabel"
                                            >
                                                {{ $t('labels.rotationCard').toUpperCase() }} <br />
                                                <v-tooltip top>
                                                    <template v-slot:activator="{on, attrs}">
                                                        <span
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            class="text-body-1 pa-0 cardText"
                                                        >
                                                            {{ vacancy.rotation }}
                                                        </span>
                                                    </template>
                                                    <span>{{ vacancy.rotation }}</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" md="1" class="pr-2">
                                        <v-row dense>
                                            <v-col
                                                :class="{truncateContent: !$vuetify.breakpoint.mobile}"
                                                class="text-body-2 pa-0 cardTextLabel"
                                            >
                                                {{ $t('labels.joiningDateCard').toUpperCase() }}&nbsp; <br />
                                                <v-tooltip top>
                                                    <template v-slot:activator="{on, attrs}">
                                                        <span
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            style="white-space: nowrap"
                                                            class="text-body-1 pa-0 cardText"
                                                        >
                                                            {{ vacancy.joining_date_display }}
                                                        </span>
                                                    </template>
                                                    <span>{{ vacancy.joining_date_display }}</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" md="1" class="d-none d-md-block" @click.stop>
                                        <v-btn
                                            style="border-radius: 8px"
                                            block
                                            color="#f6bb14"
                                            class="white--text text-none font-weight-bold pt-4 pb-4 buttons-font"
                                            @click="openModal(true, vacancy.id)"
                                        >
                                            {{ $t('buttons.apply') }}
                                        </v-btn>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="1"
                                        class="d-md-none d-flex justify-center align-center"
                                        @click.stop
                                    >
                                        <v-btn
                                            style="border-radius: 8px"
                                            depressed
                                            text
                                            class="text-none font-weight-bold buttons-font"
                                            id="no-background-hover"
                                            @click="vacancy.show_more = !vacancy.show_more"
                                        >
                                            <span v-show="!vacancy.show_more">
                                                <v-icon x-small color="#6F6F6F">fas fa-chevron-down</v-icon>
                                                &nbsp;
                                                {{ $t('buttons.moreDetails') }}</span
                                            >
                                            <span v-show="vacancy.show_more">
                                                <v-icon x-small color="#6F6F6F">fas fa-chevron-up</v-icon>
                                                &nbsp;
                                                {{ $t('buttons.lessDetails') }}</span
                                            >
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-expand-transition>
                                <div v-show="vacancy.show_more">
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <v-col cols="12">
                                                <v-col class="text-body-2 pa-0 cardTextLabel">
                                                    <b>{{ $t('labels.additionalInformation') }} &nbsp; </b>
                                                    <span class="cardText">
                                                        {{ vacancy.additional_information }}
                                                    </span>
                                                </v-col>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-col class="text-body-2 pa-0 cardTextLabel">
                                                    <b>{{ $t('labels.jobRequirements') }} &nbsp;</b>
                                                    <span class="cardText">
                                                        {{ vacancy.job_requirements }}
                                                    </span>
                                                </v-col>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-col class="text-body-2 pa-0 cardTextLabel">
                                                    <b>{{ $t('labels.vesselInformation') }} &nbsp;</b>
                                                    <span class="cardText">
                                                        {{ vacancy.vessel_information }}
                                                    </span>
                                                </v-col>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </div>
                            </v-expand-transition>
                            <v-row>
                                <v-col cols="12" class="pa-6 d-md-none">
                                    <v-btn
                                        style="border-radius: 8px"
                                        block
                                        color="#f6bb14"
                                        class="white--text text-none font-weight-bold pa-6 buttons-font"
                                        @click.stop
                                        @click="openModal(true, vacancy.id)"
                                    >
                                        {{ $t('buttons.apply') }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card>
                    </div>
                </v-col>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12">
                <v-col class="text-center">
                    <v-btn
                        v-if="moreToshow"
                        style="border-radius: 8px"
                        @click="loadMore"
                        color="#0da6b1"
                        class="white--text text-none font-weight-bold buttons-font"
                    >
                        {{ $t('buttons.loadMore') }}
                    </v-btn>
                </v-col>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <Modal :show-modal="showModal" :max-width="350">
                    <EmailVerification
                        :open-application="openApplication"
                        :vacancy-application="vacancyApplication"
                        :vacancy-id="vacancyId"
                        @success="openSuccessModal"
                        @close="closeModal"
                    ></EmailVerification>
                </Modal>
            </v-col>
            <v-col>
                <Modal :show-modal="showSuccessModal" :max-width="400">
                    <SuccessMessage @close="closeSuccessModal"></SuccessMessage>
                </Modal>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Modal from '../../trinkets/Modal.vue';
import EmailVerification from './EmailVerification.vue';
import SuccessMessage from './SuccessMessage.vue';

export default {
    name: 'Vacancies',
    components: {Modal, EmailVerification, SuccessMessage},
    data: function () {
        return {
            publicPath: process.env.BASE_URL,
            vacanciesAll: [],
            length: 10,
            moreToshow: true,
            showModal: false,
            showSuccessModal: false,
            openApplication: false,
            vacancyApplication: false,
            vacancyId: null,
        };
    },

    methods: {
        openModal(vacancyApplication, vacancyId = null, openApplication = false) {
            this.showModal = true;
            this.vacancyId = vacancyId;
            this.openApplication = openApplication;
            this.vacancyApplication = vacancyApplication;
        },
        openSuccessModal() {
            this.showSuccessModal = true;
        },
        closeSuccessModal() {
            this.showSuccessModal = false;
        },
        closeModal() {
            this.showModal = false;
            this.vacancyId = null;
            this.openApplication = false;
            this.vacancyApplication = false;
        },
        redirect() {
            window.location.href = 'https://www.azara.hr';
        },
        loadMore() {
            this.length = this.length + 3;
            if (this.length > this.vacanciesAll.length) {
                this.moreToshow = false;
            }
        },
        getTemplate() {
            let vm = this;
            this.$APICall('get', 'application-form-template', {}, (data, success) => {
                if (success) {
                    window.open(data.link);
                } else {
                    vm.$alert(vm.$t('alerts.basicError'));
                }
            });
        },
        reloadVacancies() {
            this.$APICall(
                'get',
                'vacancies-for-web-registrations',
                {},
                (data, success) => {
                    if (!success) {
                        this.$alert(this.$t('alerts.basicError'));
                    } else {
                        this.vacanciesAll = data.vacancies;
                        if (this.length > this.vacanciesAll.length) {
                            this.moreToshow = false;
                        }
                    }
                },
                false,
            );
        },
    },
    computed: {
        vacanciesList() {
            return this.vacanciesAll.slice(0, this.length);
        },
    },
    mounted() {
        this.reloadVacancies();
    },
};
</script>

<style scoped>
.headings-font {
    font-family: 'Maitree-Regular', sans-serif !important;
}

.buttons-font {
    font-family: 'Nunito-Regular', sans-serif !important;
}

.headings-font-weight {
    font-weight: 600;
}

#no-background-hover::before {
    background-color: transparent !important;
}
#no-background-hover {
    background-color: transparent !important;
    font-weight: 600;
}

.text {
    color: rgba(5, 75, 97, 255);
}

.cardText {
    font-family: 'Nunito-Regular', sans-serif !important;
    font-weight: 400;
    color: rgba(5, 75, 97, 255);
}

.cardTextLabel {
    font-family: 'Nunito-Regular', sans-serif !important;
    font-weight: 700;
    color: rgba(5, 75, 97, 255);
}

.cardTextLabelMobile {
    font-family: 'Nunito-Regular', sans-serif !important;
    font-weight: 400;
    color: rgba(5, 75, 97, 255);
}
.openVacancies {
    font-family: 'Nunito-Regular', sans-serif !important;
    font-size: 1.5em;
}

.descriptionText {
    font-family: 'Nunito-Regular', sans-serif !important;
    font-weight: 500;
}

.truncateContent {
    display: -webkit-box;
    line-clamp: 3;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.link-style {
    cursor: pointer;
    text-decoration: underline;
}

.item-height {
    min-height: 120px;
}
</style>
